import * as yup from "yup"
import { Box } from "@mui/material"
import { Form } from "formik"
import { Formik } from "../../../../forms/SchemaFormik"
import { useAppLocalization } from "../../../../../../modules/localization/components/AppLocalizationProvider"
import { CreateUpdateAttendeesFormContent } from "./CreateUpdateAttendeesFormContent"
import { FieldsParams } from "../../../../createOrder/components/form/formTypes"
import { CreateUpdateAttendeesFormValues } from "./attendeesTypes"

type CreateUpdateAttendeesFormProps = Readonly<{
    initialValues: CreateUpdateAttendeesFormValues | null
    handleChangeAttendees: (list: CreateUpdateAttendeesFormValues) => void
    submitButtonText: string
    fieldsParams?: FieldsParams[]
}>

export const attendeeInitValues = {
    name: "",
    company: "",
    isExternal: false,
}

export function CreateUpdateAttendeesForm({
    initialValues,
    handleChangeAttendees,
    submitButtonText,
    fieldsParams,
}: CreateUpdateAttendeesFormProps) {
    const { l10n } = useAppLocalization()

    const validationSchema = yup.object({
        attendees: yup.array().of(
            yup.object({
                name: yup
                    .string()
                    .nullable()
                    .default("")
                    .transform((value) => (typeof value === "string" ? value.trim() : ""))
                    .test("name-required-if-company", l10n.getString("required-field"), function (value) {
                        const company = this.parent.company
                        if (!value && !company) return true
                        return !!value
                    }),

                company: yup
                    .string()
                    .nullable()
                    .default("")
                    .transform((value) => (typeof value === "string" ? value.trim() : ""))
                    .test("company-required-if-name", l10n.getString("required-field"), function (value) {
                        const name = this.parent.name
                        if (!value && !name) return true
                        return !!value
                    }),
            }),
        ),
    })

    const defaultInitialValues = {
        attendees: [attendeeInitValues],
    }

    function handleSubmit(values: CreateUpdateAttendeesFormValues) {
        const filteredValues = {
            attendees: values.attendees.filter((attendee) => attendee.name || attendee.company),
        }

        handleChangeAttendees(filteredValues)
    }

    return (
        <Box width="100%" maxWidth="72rem">
            <Formik<CreateUpdateAttendeesFormValues>
                enableReinitialize
                initialValues={initialValues ?? defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                validateOnChange={false}
            >
                <Form>
                    <CreateUpdateAttendeesFormContent submitButtonText={submitButtonText} fieldsParams={fieldsParams} />
                </Form>
            </Formik>
        </Box>
    )
}
